(() => {
  function init(root) {
    if(root.dataset.ready) return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-pm-form]');
    const variants = JSON.parse(root.querySelector('[data-pm-variants]').textContent);
    const strings = JSON.parse(root.querySelector('[data-pm-strings]').textContent);
    const button = root.querySelector('[data-pm-submit]');
    const stickyButton = root.querySelector('[data-pm-sticky-submit]');
    const sticky = root.querySelector('[data-pm-sticky]');
    const guide = root.querySelector('[data-pm-guide]');
    const status = root.querySelector('[data-pm-status]');
    const patchPrice = Number(root.dataset.patchPrice) || 0;
    const currency = new Intl.NumberFormat('he-IL',{style:'currency',currency:window.Shopify?.currency?.active || 'ILS'});
    let variant = null, busy = false;
    const money = cents => currency.format(cents / 100);
    function refresh() {
      const options = [];
      root.querySelectorAll('[data-pm-option]').forEach(f => { options[Number(f.dataset.pmOption)] = f.querySelector('input:checked')?.value; });
      variant = variants.find(v => v.options.every((value,i) => value === options[i])) || null;
      const selectedPatch = form.elements['pm-patch']?.value || '';
      const partial = variants.filter(v => v.options.every((value,i) => !options[i] || value === options[i]));
      const base = variant?.price ?? Math.min(...(partial.length ? partial : variants).map(v=>v.price));
      root.querySelector('[data-pm-price]').textContent = money(base);
      root.querySelector('[data-pm-total]').textContent = money(base + (selectedPatch ? patchPrice : 0));
      root.querySelector('[data-pm-sticky-total]').textContent = money(base + (selectedPatch ? patchPrice : 0));
      button.textContent = !variant ? strings.choose : variant.available ? strings.add : strings.unavailable;
      button.disabled = busy || !!(variant && !variant.available);
      stickyButton.textContent = button.textContent;
      stickyButton.disabled = button.disabled;
      const hasPrint = root.querySelector('[data-pm-name]').value.trim() || root.querySelector('[data-pm-number]').value.trim();
      root.querySelector('[data-pm-summary]').textContent = [...options.filter(Boolean),hasPrint ? strings.printed : strings.blank, selectedPatch].filter(Boolean).join(' · ');
      status.textContent = '';
    }
    form.addEventListener('change', refresh);
    form.addEventListener('input', refresh);
    window.PMConnectSizeGuide(root,variants,strings);
    const observer = new IntersectionObserver(entries => { sticky.hidden = entries[0].isIntersecting; },{threshold:0.1});
    observer.observe(root.querySelector('.pm-product__purchase'));
    root.querySelectorAll('[data-pm-image]').forEach(btn => btn.addEventListener('click', () => {
      const image = root.querySelector('.pm-product__hero');
      image.removeAttribute('srcset'); image.src = btn.dataset.pmImage;
      root.querySelectorAll('[data-pm-image]').forEach(item => item.setAttribute('aria-pressed',String(item === btn)));
    }));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if(busy || !variant || !variant.available || !form.reportValidity()) return;
      const patch = form.elements['pm-patch']?.value || '';
      if(patch && !root.dataset.patchId) { status.textContent = strings.error; return; }
      const properties = {};
      const name = root.querySelector('[data-pm-name]').value.trim();
      const number = root.querySelector('[data-pm-number]').value.trim();
      if(name) properties[strings.name] = name;
      if(number) properties[strings.number] = number;
      if(patch) { properties[strings.patch] = patch; properties._pm_patch_linked = 'true'; }
      const items = [{id:variant.id,quantity:1,properties}];
      if(patch) items.push({id:Number(root.dataset.patchId),quantity:1,parent_id:variant.id,properties:{[strings.patch]:patch}});
      busy = true; button.disabled = true; button.textContent = strings.busy; stickyButton.disabled = true; stickyButton.textContent = strings.busy; status.textContent = '';
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});
        const result = await response.json();
        if(!response.ok) throw new Error(result.description || strings.error);
        window.location.assign(root.dataset.cartUrl);
      } catch(error) { busy = false; refresh(); status.textContent = error.message || strings.error; }
    });
    refresh();
  }
  document.querySelectorAll('[data-pm-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-pm-product]').forEach(init));
})();


